// DS1.7.17
import React from 'react';
import classnames from 'classnames';
import s from './BirthdayBadge.scss';
const BirthdayBadge = ({ size, className })=>{
    return /*#__PURE__*/ React.createElement("img", {
        src: "https://st.deviantart.net/eclipse/global/svg/birthday-badge.svg",
        alt: "",
        className: classnames(s['root'], s[`size-${size}`], className)
    });
};
BirthdayBadge.displayName = 'BirthdayBadge';
export default BirthdayBadge;
